import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from "redux-form";
import login from "./loginReducer";
import signUp from "./signUpReducer";
import verification from "./verificationReducer";
import user from "./userReducer";
import landlord from "./landlordReducer";
import passwordreset from "./passwordresetReducer";
import {adminReducer} from './admin'
// import tenant from "./tenantReducer";
import error from './error'
import {propertyReducer} from './property'
import {usersReducer} from './users'

export default ( history ) => combineReducers({
    router: connectRouter( history ),
    form: formReducer,
    login,
    signUp,
    propertyReducer,
    verification,
    user,
    landlord,
    passwordreset,
    adminReducer,
    usersReducer,
    // tenant,
    error
});